// src/components/table/columnsConfig/ConvertsAttributeDataColumns.js
import { Box, IconButton, Tooltip } from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon, Add as AddIcon } from "@mui/icons-material";

export const getSecurityDataColumns = (
  theme,
  {
    onStartEdit,
    onDeleteClick,
  }
) => [
  {
    header: "ISIN",
    accessorKey: "isin",
    size: 120,
    enableSorting: true,
    enableColumnFilter: false,
  },
  {
    header: "Name",
    accessorKey: "name",
    size: 150,
    enableSorting: true,
    enableColumnFilter: false,
  },
  {
    header: "Conversion Ratio",
    accessorKey: "conversion_ratio",
    size: 150,
    enableSorting: true,
    enableColumnFilter: false,
    Cell: ({ row }) => {
      const currentConversionRatio = row.original.conversion_ratio;
      return <span>{currentConversionRatio || "N/A"}</span>;
    },
  },
  {
    header: "Exclude?",
    accessorKey: "exclude_from_scanner",
    size: 100,
    enableSorting: true,
    enableColumnFilter: false,
    Cell: ({ row }) => {
      const currentExcludeFromScanner = row.original.exclude_from_scanner;
      return <span>{currentExcludeFromScanner ? "Yes" : "No"}</span>;
    },
  },
  {
    header: "Actions",
    accessorKey: "actions",
    size: 80,
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ row }) => {
      const isin = row.original.isin;

      return (
        <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
          <Tooltip title="Edit">
            <IconButton
              onClick={() =>
                onStartEdit(
                  isin,
                  row.original.conversion_ratio,
                  row.original.exclude_from_scanner,
                  row.original.id
                )
              }
              size="small"
              sx={{
                color: theme.palette.secondary.main,
                "&:hover": {
                  backgroundColor: theme.palette.secondary.light,
                  color: theme.palette.secondary.dark,
                },
              }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              onClick={() => onDeleteClick(isin, row.original.id)}
              size="small"
              sx={{
                color: theme.palette.error.main,
                "&:hover": {
                  backgroundColor: theme.palette.error.light,
                  color: theme.palette.error.dark,
                },
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      );
    },
  },
];

export const getMissingConversionRatioColumns = (
  theme,
  {
    onStartEdit,
  }
) => [
  {
    header: "ISIN",
    accessorKey: "isin",
    size: 120,
    enableSorting: true,
    enableColumnFilter: false,
  },
  {
    header: "Name",
    accessorKey: "name",
    size: 150,
    enableSorting: true,
    enableColumnFilter: false,
  },
  {
    header: "Add Conversion Ratio",
    accessorKey: "addConversionRatio",
    size: 150,
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ row }) => {
      const isin = row.original.isin;

      return (
        <Tooltip title="Add Conversion Ratio">
          <IconButton
            onClick={() => onStartEdit(isin, row.original.name)}
            size="small"
            sx={{
              color: theme.palette.secondary.main,
              "&:hover": {
                backgroundColor: theme.palette.secondary.light,
                color: theme.palette.secondary.dark,
              },
            }}
          >
            <AddIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      );
    },
  },
];
